import React from "react";
import {Container, Tab, Tabs} from "react-bootstrap";
import {DismissibleAlert} from "../Alerts/DismissibleAlert";
import "../CommonCss/Container.css"
import "./DataConversion.css"
import {CTGAlphaLISAInputForm} from "./CTGAlphaLISAInputForm";
import {IC50BindingInputForm} from "./IC50BindingInputForm";

interface DataConversionState {
    errorMessage: string
    selectedTab: string
}

export class DataConversion extends React.Component<any, DataConversionState> {
    constructor(props: any) {
        super(props);
        this.state = {
            errorMessage: "",
            selectedTab: "ctg"
        }
    }


    showErrorAlert(message: string) {
        this.setState({
            errorMessage: message
        })
    }

    handleTabSelect = (selectedTab: string | null) => {
        this.setState({
            selectedTab: selectedTab || "ctg"
        })
    }

    renderTabContent() {
        switch (this.state.selectedTab) {
            case "ctg":
                return <CTGAlphaLISAInputForm protocol="ctg" />
            case "alphalisa":
                return <CTGAlphaLISAInputForm protocol="alphalisa" />
            case "ic50-binding":
                return <IC50BindingInputForm />
            default:
                return <CTGAlphaLISAInputForm protocol="ctg" />
        }
    }

    render() {
        return (
            <>
                <DismissibleAlert message={this.state.errorMessage}/>
                <Tabs activeKey={this.state.selectedTab} onSelect={this.handleTabSelect} id="data-conversion-tab" className="mb-3 data-conversion-tabs">
                    <Tab eventKey="ctg" title="CTG">
                        <Container className="p-4 bg-light wide-container">
                            {this.renderTabContent()}
                        </Container>
                    </Tab>
                    <Tab eventKey="alphalisa" title="AlphaLISA">
                        <Container className="p-4 bg-light wide-container">
                            {this.renderTabContent()}
                        </Container>
                    </Tab>
                    <Tab eventKey="ic50-binding" title="IC50 Binding">
                        <Container className="p-4 bg-light wide-container">
                            {this.renderTabContent()}
                        </Container>
                    </Tab>
                </Tabs>
            </>
        );
    }
}
